export function setHash(newHash: string): void {
  /* istanbul ignore next */
  if (window !== undefined) {
    window.history.pushState({}, document.title, `#${newHash}`);
  }
}
